// The WhatsApp glyph, drawn in the site's stroke style (no brand asset,
// no emoji). Sized by the parent via `size`.
export function WhatsAppIcon({ size = 16 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3.5 16.5l.9-2.7a6.6 6.6 0 1 1 2.4 2.1L3.5 16.5z" />
      <path d="M7.7 7.8c0 2.7 1.8 4.5 4.5 4.5" />
    </svg>
  )
}
